import { SET_COMPONENT } from "../../utils/constantes";

const setComponent = (payload) => {
    return{
        type: SET_COMPONENT,
        payload
    }
};

export default setComponent;